import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFormComponent } from './containers/dynamic-form/dynamic-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FormInputComponent } from './containers/form-input/form-input.component';
import { FormSelectComponent } from './containers/form-select/form-select.component';
import { FormTextareaComponent } from './containers/form-textarea/form-textarea.component';
import { DynamicFieldDirective } from './containers/dynamic-field/dynamic-field.directive';
import { DragDropModule  } from '@angular/cdk/drag-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EditFormFieldsComponent } from './containers/edit-form-fields/edit-form-fields.component';
import { FormRenderComponent } from './containers/form-render/form-render.component';
import { FormPreviewComponent } from './containers/form-preview/form-preview.component';
import { FormCheckboxComponent } from './containers/form-checkbox/form-checkbox.component';
import { FormRadioComponent } from './containers/form-radio/form-radio.component';
import { FormFileComponent } from './containers/form-file/form-file.component';
import { FormTermsComponent } from './containers/form-terms/form-terms.component';
import { FormInfoMessageComponent } from './containers/form-info-message/form-info-message.component';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DragDropModule,
    NgbModule,
    FormsModule,
    RecaptchaModule,
    RecaptchaFormsModule
  ],
  declarations: [
    DynamicFieldDirective,
    DynamicFormComponent,
    EditFormFieldsComponent,
    FormRenderComponent,
    FormPreviewComponent,
    FormInputComponent,
    FormSelectComponent,
    FormTextareaComponent,
    FormCheckboxComponent,
    FormRadioComponent,
    FormFileComponent,
    FormTermsComponent,
    FormInfoMessageComponent
  ],
  exports: [DynamicFormComponent, FormPreviewComponent, FormRenderComponent],
  entryComponents: [
    FormTextareaComponent,
    FormInputComponent,
    FormSelectComponent,
    FormCheckboxComponent,
    FormRadioComponent,
    FormFileComponent,
    FormTermsComponent,
    FormInfoMessageComponent
  ]
})
export class DynamicFormModule { }
